import ContratoInterceptor from '../ContratoInterceptor'

const api = new ContratoInterceptor()

export default {
  getPrestadores() {
    return api.get(`/prestadores`)
  },

  getPrestadoresUserGestor() {
    return api.get('/users/current/contratos/prestadores')
  },

  getPrestadoresByUser() {
    return api.get(`/prestadores/user`)
  },
}
